import React from 'react';
import {Button, FlexRow} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';
import {useReportBuilder} from '../ReportBuilderContext';
import {ReportDownloadMenu} from './ReportDownloadMenu';
import {ReportShareButton} from './ReportShareButton';

/** Top bar shown in view mode. Editors additionally see "Share" and "Edit Report" (opens the edit
 * session via `beginEdit()`, which switches `mode` to `'edit'` once the draft is opened); readers
 * only ever see "Download". Download exports the report. Share opens the report-sharing dialog once
 * the report is saved; on an unsaved draft it stays disabled with a tooltip explaining why, since a
 * draft has no Reports-list entry to share. Left-to-right order is Download, Share, Edit Report,
 * matching the design — the reverse of DOM/visual emphasis order used previously. Download and Share
 * are monochrome (grey-bordered) like every secondary action in both bars; only the one primary
 * action per bar carries the filled high-emphasis treatment. */
export function ViewTopBar(): JSX.Element {
	const {formatMessage} = useIntl();
	const {role, beginEdit} = useReportBuilder();

	return (
		<FlexRow justifyContent={'flex-end'} alignItems={'center'} gap={'s'} data-cy={'ai-report-view-top-bar'}>
			<ReportDownloadMenu />
			<ReportShareButton />
			{role === 'editor' ? (
				<Button
					emphasis={'high'}
					icon={'edit'}
					onPress={() => void beginEdit()}
					data-cy={'ai-report-edit-report-button'}
				>
					{formatMessage({id: 'ai_report_builder.edit_report'})}
				</Button>
			) : null}
		</FlexRow>
	);
}
